import { useContext } from 'react';
import LegoAdminPageContext from '../../legoAdminPageContext';
import { IconButton } from '../../../components/common/IconButton';
import AskAI from '../../../components/ai/AskAI';

export default function ExplainWithAIButton({ text }) {
  const { page } = useContext(LegoAdminPageContext);

  const explainWithAI = async () => {
    page.openModal(<div style={{ maxWidth: '800px', width: '80vw' }}>
      <AskAI prompt={`What does this vehicle spec mean? Explain in a few sentences each part of the specs:\n"${text}"`} />
    </div>, { minSize: false, title: 'Explain with AI' });
  };

  return (
    <IconButton
      icon={'tips_and_updates'}
      className={'mr-2 align-self-start'}
      level={'primary'}
      onClick={explainWithAI}
      description={'Explain with AI'}
    />
  );
} 